import { omit, pick } from '@styled-system/props';
import React from 'react';

import { ComponentProps } from '../utils/types';
import {
  CheckboxRipple,
  CheckboxRoot,
  CheckIcon,
  CheckIconContainer,
  CheckIconPath,
  InputCheckbox
} from './styles';
import CheckboxInterface from './types';

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxInterface>(
  ({ colorSchema = 'active', rounded = false, ...props }, ref) => (
    <CheckboxRoot {...pick(props)}>
      <InputCheckbox {...omit(props)} type="checkbox" ref={ref} />
      <CheckIconContainer
        rounded={rounded}
        colorSchema={colorSchema}
        aria-hidden
      >
        <CheckIcon viewBox="0 0 24 24">
          <CheckIconPath
            fill="none"
            stroke="white"
            d="M1.73,12.91 8.1,19.28 22.79,4.59"
          />
        </CheckIcon>
      </CheckIconContainer>
      <CheckboxRipple colorSchema={colorSchema} aria-hidden />
    </CheckboxRoot>
  )
);

export type CheckboxProps = ComponentProps<typeof Checkbox>;
export default Checkbox;
